import { useEffect } from "react"

import { useLayerPopupContext } from "@shared/contexts"
import { isWindow7 } from "@shared/modules"

export default function useInstallChromePopup() {
  const { open } = useLayerPopupContext()

  useEffect(() => {
    if (!isWindow7) return

    open("INSTALL_CHROME")
  }, [open])
}
